import { render } from "./wms-romaneio-expedir.vue?vue&type=template&id=24a51f0e"
import script from "./wms-romaneio-expedir.vue?vue&type=script&lang=js"
export * from "./wms-romaneio-expedir.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__